import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

// Add global error handling
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  // Prevent the default behavior (crash)
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});

// Add production logging
if (process.env.NODE_ENV === 'production') {
  const originalConsoleLog = console.log;
  console.log = (...args) => {
    // This will show up in Coolify logs
    originalConsoleLog(...args);
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
